import { Button, Col, Form, Input, Row, Space, theme, Table, Select, Tooltip, message, DatePicker } from 'antd';
import React, { useEffect, useState } from 'react';
import LoadingBase from '../../components/LoadingBase';
import '../../css/listbook-page.css';
import { DATE_FORMAT, FORMAT_DATE, HeaderTableChildCus, HeaderTableCus, LIST_SEX, LIST_UNITS, STATUS_ORDER, STATUS_SERVICES, TYPE_METHOD_SUPPORT, TYPE_RESULT_SUPPORT, TYPE_TICKET } from '../../constants/constants';
import { SearchOutlined } from '@ant-design/icons';
import { filterOption, formatNumber, getSelectedBranch } from '../../utils/funcHelper';
import dayjs from 'dayjs';
import { consoleLogUtil } from '../../utils/consoleLogUtil';
import { useSelector } from 'react-redux';
import { customer_services_detail, customer_services_update_status, customers_with_services, getListAccount, getListBranches, list_customer_care_logs } from '../../services/apis';
import ServiceDetailModal from './modal/ServiceDetailModal';



const ListCustomerLogsPage = () => {
    const { token } = theme.useToken();
    const [form] = Form.useForm();

    const initialValues = {
        date: [dayjs().startOf('day'), dayjs().endOf('day')],
        branch_id: getSelectedBranch()?.id ?? null,
    };

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [itemSelected, setItemSelected] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(20);
    const [totalRecords, setTotalRecords] = useState(0);
    const userReducer = useSelector((state) => state?.userReducer?.data);
    const [employees, setEmployees] = useState([]);
    const [isShowModalDetailService, setIsShowModalDetailService] = useState(false);
    const [dataPositions, setDataPositions] = useState([]);
    const [dataBranches, setDataBranches] = useState([]);
    const { RangePicker } = DatePicker;
    const columns = [
        {
            title: 'STT',
            align: 'center',
            width: 60,
            render: (text, record, index) => <div>{(currentPage - 1) * currentPageSize + index + 1}</div>,
        },
        {
            title: 'Tên khách hàng',
            dataIndex: 'customer_name',
            key: 'customer_name',
            width: 200,
            render: (text, record, index) => <div
                style={{
                    paddingLeft: 0, paddingRight: 12
                }}>
                <strong>{text}</strong>
            </div>,
        },
        {
            title: 'Số điện thoại',
            dataIndex: 'phone',
            key: 'phone',
            width: 100,
            align: 'center',
            render: (text, record, index) => <div>
                {text}
            </div>,
        },
        {
            title: 'Giới tính',
            dataIndex: 'gender',
            key: 'gender',
            width: 120,
            align: 'center',
            render: (text, record, index) => <div>{text ? LIST_SEX.find(item => item.value === text).label : ''}</div>
        },
        {
            title: 'Ngày sinh',
            dataIndex: 'birthday',
            key: 'birthday',
            width: 120,
            align: 'center',
            render: (text, record, index) => <div>{(text && text !== '0000-00-00') ? dayjs(text).format(DATE_FORMAT.DDMMYYYY_FORMAT) : ''}</div>
        },
        {
            title: 'Địa chỉ',
            dataIndex: 'address',
            key: 'address',
            width: 120,
            render: (text, record, index) => <div>{text?.length > 50 ?
                <Tooltip
                    placement="topLeft"
                    title={text}
                >
                    <span>{text?.substring(0, 50)}...</span>
                </Tooltip> : `${text}`
            }</div>,
        }
    ];

    const expandColumns = [
        {
            title: 'Dịch vụ sử dụng',
            dataIndex: 'service_name',
            key: 'service_name',
            render: (text, record, index) => <div style={{
                display: 'flex', flexDirection: 'column', cursor: 'pointer'
            }}>
                <div style={{
                    paddingLeft: 6, paddingRight: 12, wordWrap: "break-word",
                    whiteSpace: "normal",
                }}><Tooltip title={text}><a>{text?.length > 100 ? text?.substring(0, 100)?.concat("...") : text}</a></Tooltip></div>
            </div>,
        },
        {
            title: 'Chi nhánh',
            dataIndex: 'branch_name',
            key: 'branch_name',
            width: 100,
            align: 'center',
            render: (text, record, index) => <div>
                {text}
            </div>,
        },
        {
            title: 'Đơn vị',
            dataIndex: 'type',
            align: 'center',
            key: 'type',
            render: (text, record, index) => <div>{text ? TYPE_TICKET.find(item => item.value === text)?.label : ''}</div>,
        },
        {
            title: 'Bắt đầu',
            dataIndex: 'start_date',
            align: 'center',
            key: 'start_date',
            render: (text, record, index) => <div>{text ? dayjs(text).format(DATE_FORMAT.DDMMYYYY_FORMAT) : ''}</div>,
        },
        {
            title: 'Kết thúc',
            align: 'center',
            dataIndex: 'end_date',
            key: 'end_date',
            render: (text, record, index) => <div>{text ? dayjs(text).format(DATE_FORMAT.DDMMYYYY_FORMAT) : ''}</div>,
        },
        {
            title: 'Trạng thái',
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            render: (text, record, index) => <div style={{ color: text === 'completed' ? 'blue' : 'black' }}>{text ? STATUS_SERVICES.find(item => item.value === text)?.label : ''}</div>,
        },
        {
            title: 'S.buổi sd',
            dataIndex: 'used_sessions',
            key: 'used_sessions',
            align: 'center',
        },
        {
            title: 'Tổng tiền',
            dataIndex: 'final_amount',
            key: 'final_amount',
            align: 'center',
            render: (text, record, index) => <div style={{textAlign: 'end'}}>{text ? formatNumber(text, 0) : 0}</div>,
        }
    ];

    const formStyle = {
        maxWidth: 'none',
        background: 'white',
        borderRadius: token.borderRadiusLG,
        paddingLeft: 0,
        paddingRight: 0,
        marginBottom: 12,
    };

    const getDataServiceDetail = async (service_id) => {

        try {
            const params = {
                id: service_id,
            }
            setLoading(true);
            const res = await customer_services_detail(params);
            if (res && res.status === 1) {
                setItemSelected(res?.data);
                setIsShowModalDetailService(true);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {
            consoleLogUtil("error", error);
        } finally {
            setLoading(false);
        }

    }


    const getDataCustomerLogs = async (page, showLoading, pageSize) => {
        try {
            const params = {
                keyword: form.getFieldValue('keyword') ?? null,
                branch_id: form.getFieldValue('branch_id') ?? null,
                page: page ?? currentPage,
                limit: pageSize ?? currentPageSize,
            }
            if (showLoading) setLoading(true);
            const res = await customers_with_services(params);
            if (showLoading) setLoading(false);
            consoleLogUtil("res customers_with_services", res);
            if (res && res.status === 1) {
                setData([...res?.data?.data]);
                setTotalRecords(res?.data?.pagination?.total_records ?? 0);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
                setData([]);
                setTotalRecords(0);
            }
        } catch (error) {

        }

    }

    const getDataUsers = async () => {
        try {
            const params = {
                keyword: '',
                branch_id: getSelectedBranch()?.id ?? null,
                limit: 100,
                currentPage: 1,
            }

            const res = await getListAccount(params);
            if (res && res.status === 1) {
                setEmployees([...res?.data?.data?.map(item => ({ ...item, value: item.id, label: item.fullname }))]);
            } else {
                setEmployees([]);
            }
        } catch (error) {
            setLoading(false);
            console.log('error', error);
        }
    }

    const onFinish = async (dataForm) => {
        setCurrentPage(1);
        getDataCustomerLogs(1, true);
    };

    const handleSaveServiceDetail = async (data) => {
        try {
            const params = {
                id: data?.id,
                status: data?.status,
                updated_by: userReducer?.user_info?.id
            }
            setLoading(true);
            const res = await customer_services_update_status(params);
            if (res && res.status === 1) {
                message.success('Cập nhật dịch vụ thành công');
                getDataCustomerLogs(1, true);
            } else {
                message.error(res.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {
            consoleLogUtil("error", error);
        } finally {
            setLoading(false);
        }
    }

    const getDataBranches = async () => {
        try {
            const params = {
                keyword: '',
            }
            const res = await getListBranches(params);
            if (res && res.status === 1) {
                setDataBranches([...res?.data?.data?.map(item => ({ ...item, value: item.id, label: item.name }))]);
            } else {
                setDataBranches([]);
            }
        } catch (error) {
            setLoading(false);
            console.log('error', error);
        }


    }

    const ExpandedTable = React.memo(({ columns, dataSource }) => {
        return (
            <Table
                components={HeaderTableChildCus}
                columns={columns}
                dataSource={dataSource}
                bordered
                pagination={false}
                onRow={(record, rowIndex) => {
                    return {
                        onClick: event => {
                            getDataServiceDetail(record?.customer_service_id);
                        },
                        onMouseEnter: event => {
                            event.currentTarget.style.cursor = 'pointer';
                        }, // hover row
                    };
                }}

            />
        );
    });

    const expandedRowRender = (record) => {
        const childData = record.services || [];

        return <ExpandedTable
            columns={expandColumns}
            dataSource={childData}
        />
    };

    useEffect(() => {
        setLoading(true);
        Promise.all([getDataUsers(), getDataBranches()]).finally(() => setLoading(false));
    }, [])

    useEffect(() => {
        if (form) {
            form.setFieldsValue(initialValues);
            getDataCustomerLogs(1, true)
        }
    }, [form])

    return (
        <div className='container-content'>

            <Form form={form} name="advanced_search" style={formStyle} onFinish={onFinish}>
                <Row gutter={24}>
                    <Col span={6}>
                        <Form.Item
                            name={'keyword'}
                        >
                            <Input
                                placeholder={'Nhập tên khách hàng, số điện thoại'} 
                                className='custom-input-antd'
                            />

                        </Form.Item>
                    </Col>

                    <Col span={5}>
                        <Form.Item
                            name="branch_id"
                        >
                            <Select
                                showSearch
                                allowClear
                                placeholder={'Chọn cơ sở'}
                                className='custom-input-antd'
                                defaultActiveFirstOption={false}
                                filterOption={filterOption}
                                notFoundContent={null}
                                options={dataBranches}
                            />
                        </Form.Item>
                    </Col>
                    
                    <Col span={2}>
                        <Space size="small">
                            <Tooltip title="Tìm kiếm">
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    className='custom-input-antd'
                                >
                                    <SearchOutlined /> Lọc dữ liệu
                                </Button>
                            </Tooltip>

                        </Space>
                    </Col>
                </Row>
            </Form>

            <Table
                components={HeaderTableCus}
                columns={columns}
                dataSource={data}
                expandable={{ expandedRowRender}}
                bordered
                rowKey={(record) => record?.customer_id}
                scroll={{ x: 'max-content' }}
                onRow={(record, rowIndex) => {
                    return {
                        onClick: event => {
                            
                        }, // click row
                        onMouseEnter: event => {
                            event.currentTarget.style.cursor = 'pointer';
                        }, // hover row
                    };
                }}
                pagination={{
                    pageSize: currentPageSize,
                    current: currentPage,
                    total: totalRecords,
                    onChange: (page, size) => {
                        setCurrentPage(page);
                        getDataCustomerLogs(page, true, size);
                    },
                    showSizeChanger: true,
                    showTotal: (total) => `Tổng ${total} khách hàng`,
                    pageSizeOptions: ['20', '30', '50'],
                    onShowSizeChange: (current, size) => {
                        setCurrentPageSize(size);
                        setCurrentPage(1);
                        getDataCustomerLogs(1, true, size);
                    }
                }}
            />

            <ServiceDetailModal
                visible={isShowModalDetailService}
                onClose={() => setIsShowModalDetailService(false)}
                data={itemSelected}
                employees={employees}
                positions={dataPositions}
                onSave={handleSaveServiceDetail}
            />
            <LoadingBase loading={loading} />
        </div>
    )
}
export default React.memo(ListCustomerLogsPage);